import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

import "./Things.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import Carousel from "../../../../components/Carousel";
import { Item } from "../../../../components/Carousel/styles";

import ThingsServices from "../../../../redux/services/categories/Things/programs";
const Things = () => {
  const [isLoading, setIsLoading] = useState(true);

  const [nextBack, setNextBack] = useState({
    next: null,
    back: null,
  });
  const [images, setImages] = useState([]);

  const [sound, setSound] = useState({
    first: null,
    right: null,
    rightSound: null,
    wrong1: null,
    wrong2: null,
  });
  useEffect(() => {
    ThingsServices.Things("things").then((res) => {
      setSound({
        first: `https://maharttafl.com/sound/${res.data.things.sound}`,
        right: `https://maharttafl.com/sound/${res.data.things.right}`,
        rightSound: `https://maharttafl.com/sound/${res.data.things.rightsound}`,
        wrong1: `https://maharttafl.com/sound/horn.mp3`,
        wrong2: `https://maharttafl.com/sound/horn.mp3`,
      });
      // //console.log(res.data);
      setImages(res.data.things.images);
      setNextBack({ ...nextBack, next: res.data.next });
      setNextBack({ ...nextBack, back: res.data.previous });
      setIsLoading(false);
    });
  }, [isLoading]);
  const chooseAudio = async () => {
    let audio = new Audio(sound.first);
    await audio.play();
  };

  const clapp = () => {
    let audio = new Audio(`https://maharttafl.com/sound/clapp.mp3`);
    audio.play();
  };
  if (isLoading) return <></>;

  return (
    <div className="games__page">
      <div>
        <button
          style={{ width: "100%" }}
          onClick={() => {
            chooseAudio();
          }}
        >
          Listen
        </button>
        <Carousel className="games__section container" keys={false}>
          {images.map((t, index) => {
            return (
              <Item>
                <img
                  src={`https://maharttafl.com/images/${t.image}`}
                  alt=""
                  style={{
                    width: "150px",
                    height: "150px",
                    border: "1px solid #dedede",
                    borderRadius: "30%",
                  }}
                  onClick={() => {
                    if (t.type === "wrong") {
                      let audio = new Audio(sound.wrong2);
                      audio.play();
                    }
                    if (t.type === "right") {
                      clapp();
                      setTimeout(() => {
                        let audio = new Audio(sound.first);
                        audio.play();
                      }, 2500);
                      setTimeout(() => {
                        let audio = new Audio(sound.rightSound);
                        audio.play();
                      }, 4500);
                    }
                  }}
                />
              </Item>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default Things;
